import { Directive, TemplateRef } from '@angular/core';

/**
 * Directive to define custom expandable row content template.
 *
 * @example
 * <app-generic-table id="users" [data]="users" [config]="tableConfig">
 *   <ng-template appTableExpandableContent let-user let-expanded="expanded" let-index="index" let-rowId="rowId">
 *     <div class="expanded-details">
 *       <button [id]="'users-btn-edit-' + rowId">Edit</button>
 *       <p>Email: {{ user.email }}</p>
 *       <p>Phone: {{ user.phone }}</p>
 *     </div>
 *   </ng-template>
 * </app-generic-table>
 */
@Directive({
  selector: '[appTableExpandableContent]',
  standalone: true,
})
export class TableExpandableContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
